"use client";

interface NameWithCodeProps {
  name?: string | null;
  code?: string | null;
  capitalizeName?: boolean;
}

export function NameWithCode({
  name,
  code,
  capitalizeName = false,
}: NameWithCodeProps) {
  if (!name && !code) return null;

  const displayName = name ?? "";

  if (!code) {
    return (
      <span className={capitalizeName ? "capitalize" : undefined}>
        {capitalizeName ? String(displayName).toLowerCase() : displayName}
      </span>
    );
  }

  return (
    <div className="leading-tight">
      <div className={capitalizeName ? "capitalize" : undefined}>
        {capitalizeName ? String(displayName).toLowerCase() : displayName}
      </div>
      <div className="text-xs text-muted-foreground">{code}</div>
    </div>
  );
}
